import Image from "next/image";
import {useEffect, useState} from "react";

export const ContextLoadingOverlay: React.FC = () => {
  const [isAlmostDone, setIsAlmostDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAlmostDone(true);
    }, 2000); // Switch after 2 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-white">
      {/* Logo */}
      <div className="mb-6">
        <Image
          src="/images/loading-lines.webp"
          alt="Loading Logo"
          width={120}
          height={120}
          className="animate-pulse"
        />
      </div>

      {/* Loading text */}
      <div className="text-lg font-medium text-gray-700">
        {isAlmostDone ? "Almost finished..." : "Loading..."}
      </div>

      {/* Progress bar */}
      <div className="mt-4 h-2 w-64 overflow-hidden rounded-full bg-gray-200">
        <div className="animate-progress h-full bg-blue-500"></div>
      </div>
    </div>
  );
};
